//New JS / New Requirement

document.addEventListener('DOMContentLoaded', () => {

  // const avail_socks_column_hover = document.querySelectorAll('.available-bundles.available_sock_style .available-bundles_column');

  // if(avail_socks_column_hover.length > 0){
  //   avail_socks_column_hover.forEach(function(column){
  //       column.addEventListener('mouseenter',function(){
  //         console.log('hhhhh')
  //         const get_price = column.getAttribute('data-price');
  //         if(get_price){
  //           const price_div = document.querySelector('.available-bundles.available_sock_style .available-bundles_heading_content .available-bundles-head_price');
  //           if(price_div){
  //             price_div.innerHTML = 'FOR ' + get_price;
  //           }
  //         }
  //       });
  //   });
  // }


  //render products
  const wrappers = document.querySelectorAll(".product_inner_block");
  // if (wrappers.length === 0) return;

  wrappers.forEach(wrapper => {
    const handle = wrapper.dataset.collectionHandle;
    const container = wrapper.querySelector(".product-bundle_row");
    const loadMoreBtn = wrapper.querySelector(".load-more-bundle-products");
    const perPage = 20;
    let currentIndex = 0;
    let allProducts = [];

    // Fetch products list (max 250 per call)
    async function fetchCollectionProducts() {
      try {
        // const get_url = window.location.href;
        // let before_url = '';

        // if(get_url.includes('/es/')){
        //     before_url = '/es'
        // }
        // console.log(`${before_url}/collections/${handle}/products.json?limit=250`);
        // const res = await fetch(`${before_url}/collections/${handle}/products.json?limit=250`);
        const res = await fetch(`/collections/${handle}/products.json?limit=250`);
        const data = await res.json();
        allProducts = data.products || [];
        renderNextBatch();
      } catch (err) {
        console.error("Failed to load products for", handle, err);
      }
    }

    // Fetch snippet HTML for each product
    async function fetchProductSnippet(productHandle) {
      try {
        const get_url = window.location.href;
        let before_url = '';

        if(get_url.includes('/es/')){
            before_url = '/es'
        }else if(get_url.includes('/it/')){
            before_url = '/it'
        }else if(get_url.includes('/de/')){
            before_url = '/de'
        }else if(get_url.includes('/ja/')){
            before_url = '/ja'
        }else if(get_url.includes('/fr/')){
            before_url = '/fr'
        }

        const res = await fetch(`${before_url}/products/${productHandle}?view=bundle-card`);
        // const res = await fetch(`/products/${productHandle}?view=bundle-card`);
        return await res.text();
      } catch (err) {
        console.error("Snippet load error:", productHandle, err);
        return "";
      }
    }

    // Render next batch (10 items)
    async function renderNextBatch() {
      const nextProducts = allProducts.slice(currentIndex, currentIndex + perPage);
      const snippetPromises = nextProducts.map(p => fetchProductSnippet(p.handle));
      const snippets = await Promise.all(snippetPromises);
      console.log('snippets',snippets);
      snippets.forEach(html => container.insertAdjacentHTML("beforeend", html));

      // Refresh lazyload or fallback
      if (window.lazySizes && typeof lazySizes.loader !== "undefined") {
        lazySizes.loader.checkElems();
      } else {
        container.querySelectorAll('img[data-src]').forEach(img => {
          img.src = img.dataset.src;
        });
      }

      currentIndex += perPage;
      if (currentIndex >= allProducts.length) {
        loadMoreBtn.style.display = "none";
      }

      //products Var clicks
      //Remove old listeners and add fresh ones
      removeProVarClickListeners();

      const pro_var_clicks = document.querySelectorAll('.product_inner_block .grid_product_size a');
      if(pro_var_clicks.length){
        pro_var_clicks.forEach(pro_var => {
          pro_var.addEventListener('click',function(e){
            const pro_card = pro_var.closest('.grid__item');
             add_products(pro_var,pro_card);
          });
        });
      }


    }

    loadMoreBtn.addEventListener("click", renderNextBatch);
    fetchCollectionProducts();
  });

  // Utility: remove old listeners
  function removeProVarClickListeners() {
    const oldLinks = document.querySelectorAll('.product_inner_block .grid_product_size a');
    oldLinks.forEach(link => {
      const clone = link.cloneNode(true);
      link.parentNode.replaceChild(clone, link);
    });
  }
//render products

//Add products
function add_products(pro_var,pro_card){
  const products_buyer = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number');
  const products_buyer_mobile = document.querySelectorAll('.product_bundle_bottom_bar .product_buyuer_list .product_byuer_number');

  const total_pro_length = products_buyer.length;
  const selected_pros = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number .bundle-box-img');
  let selected_pro_length = selected_pros.length;

  if(selected_pro_length >= total_pro_length){
    return;
  }

  const pro_img = pro_card.querySelector('img.grid-product__image').getAttribute('src');
  const pro_var_id = pro_var.getAttribute('data-variant-id');
  const pro_price = pro_var.getAttribute('data-price');

  pro_card.classList.add('added');
  // const add_count = parseInt(card.getAttribute('data-added'));
  
  // atc_btn.textContent = 'Added (' + (add_count + 1) + ')';
  // atc_btn.classList.add('selected');

  // card.setAttribute('data-added',add_count + 1);

  //desk
  const active_buy_box = document.querySelector('.bundle-tab-content .product_buyuer_list .product_byuer_number.active');
  if(active_buy_box){
    active_buy_box.setAttribute('data-var-id',pro_var_id);
    active_buy_box.querySelector('.product_bundle_number').classList.add('hide');

    let box_html = `<div class="bundle-box-img">
                      <img src="${pro_img}" alt="">
                      <div class="bundle-close" data-step="0" data-variant="${pro_var_id}" data-index="0" data-price="${pro_price}">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <circle cx="8.5" cy="8.5" r="8" fill="#D10000"></circle>
                        <path d="M5.5 5.5L11.5 11.5M11.5 5.5L5.5 11.5" stroke="white" stroke-width="1.5" stroke-linecap="round"></path>
                        </svg>
                      </div>
                    </div>`;
    
      // Insert as the first child
      active_buy_box.insertAdjacentHTML('afterbegin', box_html);
      if(active_buy_box.nextElementSibling){
        active_buy_box.nextElementSibling.classList.add('active');
      }
      active_buy_box.classList.remove('active');
  }

  //mob
  // const active_buy_box_mob = document.querySelector('.product_bundle_bottom_bar .product_buyuer_list .product_byuer_number.active');
  // if(active_buy_box_mob){
  //   active_buy_box_mob.setAttribute('data-var-id',pro_var_id);
  //   active_buy_box_mob.querySelector('.product_bundle_number').classList.add('hide');

  //   let box_html = `<div class="bundle-box-img">
  //                     <img src="${pro_img}" alt="">
  //                     <div class="bundle-close" data-step="0" data-variant="${pro_var_id}" data-index="0">
  //                       <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
  //                       <circle cx="8.5" cy="8.5" r="8" fill="#D10000"></circle>
  //                       <path d="M5.5 5.5L11.5 11.5M11.5 5.5L5.5 11.5" stroke="white" stroke-width="1.5" stroke-linecap="round"></path>
  //                       </svg>
  //                     </div>
  //                   </div>`;
    
  //     // Insert as the first child
  //     active_buy_box_mob.insertAdjacentHTML('afterbegin', box_html);
  //     if(active_buy_box_mob.nextElementSibling){
  //       active_buy_box_mob.nextElementSibling.classList.add('active');
  //     }
  //     active_buy_box_mob.classList.remove('active');
  // }

  const pro_no_acce_total = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number:not(.product_accessories_numner)');
  const total_pro_no_acce_length = pro_no_acce_total.length;
  const selected_pros_no_acce = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number:not(.product_accessories_numner) .bundle-box-img');
  let selected_pro_no_acce_length = selected_pros_no_acce.length;

  if(selected_pro_no_acce_length == total_pro_no_acce_length){
     const products_section = document.querySelector('.product_bundle_section');

     if(products_section){
          // products_section.classList.remove('hide');

          const all_blocks = products_section.querySelectorAll('.product_inner_block');
          all_blocks.forEach(all_box => {
            all_box.classList.add('hide');
          });

          const match_block = products_section.querySelector('.product_inner_block.accessories_block');
          if(match_block){
            match_block.classList.remove('hide');
          }
      }
  }

  // const get_sel_price = parseInt(document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').getAttribute('data-price'));
  // const get_curr_price = parseInt(atc_btn.getAttribute('data-price'));
  // const total_price = get_sel_price + get_curr_price;

  // document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').setAttribute('data-price',total_price);
  const main_atc_btn = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart a.add-to-cart-btn');
  const selected_pros_total = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number .bundle-box-img');
  let selected_pro_total_length = selected_pros_total.length;

  if(selected_pro_total_length >= total_pro_no_acce_length){
    // products_buyer.forEach(function(buy_box){
    //   buy_box.classList.remove('active');
    // });

    if(main_atc_btn){
      main_atc_btn.classList.remove('disabled');
    }
  }else{
    if(main_atc_btn){
      main_atc_btn.classList.add('disabled');
    }
  }

  if(selected_pro_total_length >= total_pro_length){
    products_buyer.forEach(function(buy_box){
      buy_box.classList.remove('active');
    });
  }

       


    const pro_var_price = parseInt(pro_var.getAttribute('data-price'));
    const price_div_main = document.querySelector('.bundle-bottom-addtocart .price-section .bundle_discounttext_price');
    if(price_div_main){
      // products_bottom_bar.classList.remove('hide');
        const get_price = parseInt(price_div_main.getAttribute('data-total-price'));
      if (!isNaN(get_price)){
        const total_price = get_price + pro_var_price;

        if(total_price){
          price_div_main.innerHTML = "Total " + Shopify.formatMoney(total_price,theme.settings.moneyFormat);
          price_div_main.setAttribute('data-total-price',total_price);
        }
      }
    }

  // if(pro_card.closest('.product_inner_block').classList.contains('accessories_block')){
  //   const pro_var_price = parseInt(pro_var.getAttribute('data-price'));
  //   const price_div_main = document.querySelector('.bundle-bottom-addtocart .price-section .bundle_discounttext_price');
  //   if(price_div_main){
  //     const get_price = parseInt(price_div_main.getAttribute('data-total-price'));

  //     if(get_price){
  //       const total_price = get_price + pro_var_price;

  //       if(total_price){
  //         price_div_main.innerHTML = "Total " + Shopify.formatMoney(total_price,theme.settings.moneyFormat);
  //         price_div_main.setAttribute('data-total-price',total_price);
  //       }
         
  //     }
  //   }
  // }else{
  //   // console.log('i click')
  //   //get price
  //     const price_div_main = document.querySelector('.bundle-bottom-addtocart .price-section .bundle_discounttext_price');
  //     if(price_div_main){
  //       // products_bottom_bar.classList.remove('hide');
  //         const get_price = parseInt(price_div_main.getAttribute('data-total-price'));
  //       if (!isNaN(get_price)){
  //         const total_price = get_price + parseInt(pro_price);

  //         if(total_price){
  //           price_div_main.innerHTML = "Total " + Shopify.formatMoney(total_price,theme.settings.moneyFormat);
  //           price_div_main.setAttribute('data-total-price',total_price);
  //         }
  //       }
  //     }
  // }

 

}
//Add products


//clicking boxes
  const gift_boxes_main = document.querySelector('.available-bundles.available_gift_boxes');
  const avail_socks_main = document.querySelector('.available-bundles.available_sock_style');
  const products_section = document.querySelector('.product_bundle_section');
  const products_bottom_bar = document.querySelector('.product_bundle_bottom_bar');

  const product_gift_boxes = document.querySelectorAll('.available-bundles.available_gift_boxes .available-bundles_column');
  const avail_socks_styles = document.querySelectorAll('.available-bundles.available_sock_style .available-bundles_column');

  //on gift box click
  if(product_gift_boxes.length> 0){
    product_gift_boxes.forEach(gift_box => {
      gift_box.addEventListener('click',function(e){
        product_gift_boxes.forEach(active_box => {
          active_box.classList.remove('active');
        });

        gift_box.classList.add('active');
        if(gift_boxes_main){
          gift_boxes_main.classList.add('hide');
        }
        if(avail_socks_main){
          avail_socks_main.classList.remove('hide');
        }
      });
    });
  }

  if(avail_socks_styles.length> 0){
    avail_socks_styles.forEach(sock_style => {
      sock_style.addEventListener('click',function(e){
        const block_id = sock_style.getAttribute('data-block-id');
        const get_price = parseInt(sock_style.getAttribute('data-price'));

        avail_socks_styles.forEach(active_box => {
          active_box.classList.remove('active');
        });

        sock_style.classList.add('active');
        if(avail_socks_main){
          avail_socks_main.classList.add('hide');
        }
        if(products_section){
          products_section.classList.remove('hide');

          const match_block = products_section.querySelector('.product_inner_block[data-block-id="'+block_id+'"]');
          if(match_block){
            match_block.classList.remove('hide');
            match_block.classList.add('selected');
          }
        }

        if(products_bottom_bar){
          products_bottom_bar.classList.remove('hide');

          if(get_price){
            // products_bottom_bar.querySelector('.price-section .bundle_discounttext_price').setAttribute('data-ori-price',get_price);
            // products_bottom_bar.querySelector('.price-section .bundle_discounttext_price').setAttribute('data-total-price',get_price);
            // products_bottom_bar.querySelector('.price-section .bundle_discounttext_price').setAttribute('data-price',Shopify.formatMoney(get_price,theme.settings.moneyFormat))
            // products_bottom_bar.querySelector('.price-section .bundle_discounttext_price').innerHTML = 'Total ' + Shopify.formatMoney(get_price,theme.settings.moneyFormat);
          }
        }

      });
    });
  }
//clicking boxes



    //main ATC click
    function mergeCartItems(items) {
      const map = {};

      items.forEach(item => {
        if (!map[item.id]) {
          map[item.id] = { id: item.id, quantity: item.quantity };
        } else {
          map[item.id].quantity += item.quantity;
        }
      });

      return Object.values(map);
    }


    const main_add_to_cart = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart a.add-to-cart-btn');
    if(main_add_to_cart){
      main_add_to_cart.addEventListener('click',function(e){
        e.preventDefault();
        main_add_to_cart.textContent = 'Adding...';
        var arrPdp = [];

        const main_gift_box = document.querySelector('.available-bundles.available_gift_boxes .available-bundles_column.active')
        if(main_gift_box){
          const main_gift_var_id = main_gift_box.getAttribute('data-pro-id');
          // if(main_gift_var_id){
          if (main_gift_var_id && !isNaN(parseInt(main_gift_var_id))) {
              arrPdp.push({
                id: parseInt(main_gift_var_id),
                quantity: 1
              });
          }
        }

        var arrPdp_disc_pro = [];
        var arrPdp_disc_pro_accessory = [];
        const all_sel_products = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number');
        if(all_sel_products.length > 0) {
          all_sel_products.forEach(card => {
            const variant_id = card.getAttribute('data-var-id');
             if (variant_id && !isNaN(parseInt(variant_id))) {
            // if (variant_id) {
              arrPdp.push({
                id: parseInt(variant_id),
                quantity: 1
              });

              arrPdp_disc_pro.push({
                id: parseInt(variant_id)
              });

              // if(card.classList.contains('product_accessories_numner')){
              //   arrPdp_disc_pro_accessory.push({
              //     id: parseInt(variant_id)
              //   });
              // }else{
              //   arrPdp_disc_pro.push({
              //     id: parseInt(variant_id)
              //   });
              // }

            }
          });
        }

          if (arrPdp.length === 0) return;
        // If no products selected, prevent submission
        if (arrPdp.length === 0) {
          // console.warn("No products selected to add to cart.");
          return;
        }

        //discount code
        // const variantIds = arrPdp.map(item => item.id);
        // const variantParam = variantIds.join(',');

        // console.log('variantParam',variantParam);
        // const requestOptions = {
        //   method: "GET",
        //   redirect: "follow"
        // };

        
        // fetch(`https://pro.americansocks.com/AmericanSocksPHP/public/discount?variant=${variantParam}`, requestOptions)
        //   .then((response) => response.text())
        //   .then((result) => {
        //     console.log(result)
        //     console.log('hihih')

        //    })
        //   .catch((error) => console.error(error));


          let disc_percentage;
          const pro_bundle_sec = document.querySelector('.product_bundle_section');
          if(pro_bundle_sec){
            const get_disc = pro_bundle_sec.getAttribute('data-bundle-discount');

            if(get_disc){
              disc_percentage = get_disc;
            }
          }


          if(disc_percentage){
            console.log('disc_percentage',disc_percentage);
          const variantIds = arrPdp_disc_pro.map(item => item.id);
          const variantParam = variantIds.join(',');

          console.log('variantParam',variantParam);

          const requestOptions = {
            method: "GET",
            redirect: "follow"
          };

          fetch(`https://pro.americansocks.com/AmericanSocksPHP/public/discount?variant=${variantParam}&percentage=${disc_percentage}`, requestOptions)
            .then(response => response.json())
            .then(result => {
              console.log(result);

              // Extract discount code
              const discountCode = result?.discount?.codeDiscount?.codes?.nodes?.[0]?.code;

              // console.log("Discount Code:", discountCode);

              if (!discountCode) {
                console.warn("Discount code not found!");
                return;
              }

              // Apply discount to cart
              fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
                },
                body: JSON.stringify({
                  discount: discountCode
                })
              })
              .then(res => res.json())
              .then(response => {
                console.log("Discount Applied:", response);
              });

            })
            .catch(error => console.error(error));
          }



          // const variantIds = arrPdp_disc_pro_accessory.map(item => item.id);
          // const variantParam = variantIds.join(',');

          // console.log('variantParam',variantParam);

          // const requestOptions = {
          //   method: "GET",
          //   redirect: "follow"
          // };

          // fetch(`https://pro.americansocks.com/AmericanSocksPHP/public/discount?variant=${variantParam}&percentage=50`, requestOptions)
          //   .then(response => response.json())
          //   .then(result => {
          //     console.log(result);

          //     // Extract discount code
          //     const discountCode = result?.discount?.codeDiscount?.codes?.nodes?.[0]?.code;

          //     // console.log("Discount Code:", discountCode);

          //     if (!discountCode) {
          //       console.warn("Discount code not found!");
          //       return;
          //     }

          //     // Apply discount to cart
          //     fetch("/cart/update.js", {
          //       method: "POST",
          //       headers: {
          //         "Content-Type": "application/json",
          //         "Accept": "application/json"
          //       },
          //       body: JSON.stringify({
          //         discount: discountCode
          //       })
          //     })
          //     .then(res => res.json())
          //     .then(response => {
          //       console.log("Discount Applied:", response);
          //     });

          //   })
          //   .catch(error => console.error(error));

        //discount code

        //add items
        
        // console.log("FINAL arrPdp:", arrPdp);
        let mergedItems = mergeCartItems(arrPdp);
        
        console.log("Merged:", mergedItems);

        let formData = { items: arrPdp };
        // console.log('formData',formData);

        async function addBundleItemsSequentially(items) {
          for (let item of items) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: item.id,
                quantity: item.quantity
              })
            })
            .then(response => {
              if (!response.ok) {
                console.error("Failed on item:", item, response);
              }
              return response.json();
            })
            .then(res => {

              
            })  
            .catch(err => console.error("Error on:", item, err));
          }


          setTimeout(function() {

                main_add_to_cart.textContent = 'Add to Cart';

                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  bubbles: true
                }));
                // Remove all bundle images (desktop + mobile)
                document.querySelectorAll('.bundle-box-img').forEach(img => img.remove());

                //Reset product number visibility and active state
                document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number').forEach((item, index) => {
                  item.classList.remove('active');
                  if (index === 0) item.classList.add('active');
                  item.querySelector('.product_bundle_number').classList.remove('hide');
                });

                  const gift_boxes_main = document.querySelector('.available-bundles.available_gift_boxes');
                  const avail_socks_main = document.querySelector('.available-bundles.available_sock_style');
                  const products_section = document.querySelector('.product_bundle_section');
                  const bundle_bottom_bar = document.querySelector('.product_bundle_bottom_bar');

                  if(gift_boxes_main){
                    gift_boxes_main.classList.remove('hide');
                  }
                  if(avail_socks_main){
                    avail_socks_main.classList.add('hide');
                  }
                  if(products_section){
                    products_section.classList.add('hide');
                  }
                  if(bundle_bottom_bar){
                    bundle_bottom_bar.classList.add('hide');
                  }
                  const all_blocks = products_section.querySelectorAll('.product_inner_block');
                  all_blocks.forEach(all_box => {
                    all_box.classList.add('hide');
                    all_box.classList.remove('selected');
                  });

                  const main_atc_btn = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart a.add-to-cart-btn');
                  if(main_atc_btn){
                    main_atc_btn.classList.add('disabled');
                  }

                  //total price
                  const price_div_main = document.querySelector('.bundle-bottom-addtocart .price-section .bundle_discounttext_price');
                  if(price_div_main){
                    price_div_main.innerHTML = "Total " + Shopify.formatMoney(0,theme.settings.moneyFormat);
                    price_div_main.setAttribute('data-total-price',0);
                  }

          }, 2000);
        }

        addBundleItemsSequentially(mergedItems);


        // fetch('/cart/add.js', {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded',
        //     'X-Requested-With': 'XMLHttpRequest'
        //   },
        //   // body: JSON.stringify(formData),
        //   body: JSON.stringify({ items: mergedItems }),
        //   credentials: 'same-origin'
        // })
        // .then(response => response.json())
        // .then(res => {     
        //   main_add_to_cart.textContent = 'Add to Cart';

        //    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        //     bubbles: true
        //    }));
        //   // Remove all bundle images (desktop + mobile)
        //   document.querySelectorAll('.bundle-box-img').forEach(img => img.remove());

        //   //Reset product number visibility and active state
        //   document.querySelectorAll('.product_buyuer_list .product_byuer_number').forEach((item, index) => {
        //     item.classList.remove('active');
        //     if (index === 0) item.classList.add('active');
        //     item.querySelector('.product_bundle_number').classList.remove('hide');
        //   });

        //     const gift_boxes_main = document.querySelector('.available-bundles.available_gift_boxes');
        //     const avail_socks_main = document.querySelector('.available-bundles.available_sock_style');
        //     const products_section = document.querySelector('.product_bundle_section');
        //     const bundle_bottom_bar = document.querySelector('.product_bundle_bottom_bar');

        //     if(gift_boxes_main){
        //       gift_boxes_main.classList.remove('hide');
        //     }
        //     if(avail_socks_main){
        //       avail_socks_main.classList.add('hide');
        //     }
        //     if(products_section){
        //       products_section.classList.add('hide');
        //     }
        //     if(bundle_bottom_bar){
        //       bundle_bottom_bar.classList.add('hide');
        //     }
        //     const all_blocks = products_section.querySelectorAll('.product_inner_block');
        //     all_blocks.forEach(all_box => {
        //       all_box.classList.add('hide');
        //     });

        //     const main_atc_btn = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart a.add-to-cart-btn');
        //     if(main_atc_btn){
        //       main_atc_btn.classList.add('disabled');
        //     }

        // })
        // .catch(err => {
        //   console.error("Error adding bundle to cart:", err);
        // });


      });
    }

});






//old requirement Js
document.addEventListener('DOMContentLoaded', () => {
    const product_cards = document.querySelectorAll('.product-bundle_row .product-bunlde_column');

    const products_buyer = document.querySelectorAll('.product_bundle_buyer .product_buyuer_list .product_byuer_number');
    const products_buyer_mobile = document.querySelectorAll('.product_bundle_bottom_bar .product_buyuer_list .product_byuer_number');

    if(product_cards.length> 0){
      product_cards.forEach(card => {
        const atc_btn = card.querySelector('.bundle-add-to-box-btn a.bundle_product_btn');
        if(atc_btn){
          atc_btn.addEventListener('click',function(e){
            e.preventDefault();
            const total_pro_length = products_buyer.length;
            const selected_pros = document.querySelectorAll('.product_bundle_buyer .product_buyuer_list .product_byuer_number .bundle-box-img');
            let selected_pro_length = selected_pros.length;

            if(selected_pro_length >= total_pro_length){
              return;
            }

            
            const pro_img = card.querySelector('.product-bundle_image img').getAttribute('data-img');
            const pro_var = card.getAttribute('data-var-id');

            card.classList.add('added');
            const add_count = parseInt(card.getAttribute('data-added'));
            
            atc_btn.textContent = 'Added (' + (add_count + 1) + ')';
            atc_btn.classList.add('selected');

            card.setAttribute('data-added',add_count + 1);

            //desk
            const active_buy_box = document.querySelector('.product_bundle_buyer .product_buyuer_list .product_byuer_number.active');
            if(active_buy_box){
              active_buy_box.querySelector('.product_bundle_number').classList.add('hide');

              let box_html = `<div class="bundle-box-img">
                                <img src="${pro_img}" alt="" style="height:45px; width:45px;">
                                <div class="bundle-quantity">1</div>
                                <div class="bundle-close" data-step="0" data-variant="${pro_var}" data-index="0">
                                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <circle cx="8.5" cy="8.5" r="8" fill="#D10000"></circle>
                                    <path d="M5.5 5.5L11.5 11.5M11.5 5.5L5.5 11.5" stroke="white" stroke-width="1.5" stroke-linecap="round"></path>
                                  </svg>
                                </div>
                              </div>`;
              
               // Insert as the first child
               active_buy_box.insertAdjacentHTML('afterbegin', box_html);
               if(active_buy_box.nextElementSibling){
                  active_buy_box.nextElementSibling.classList.add('active');
               }
               active_buy_box.classList.remove('active');
            }

            //mob
            const active_buy_box_mob = document.querySelector('.product_bundle_bottom_bar .product_buyuer_list .product_byuer_number.active');
            if(active_buy_box_mob){
              active_buy_box_mob.querySelector('.product_bundle_number').classList.add('hide');

              let box_html = `<div class="bundle-box-img">
                                <img src="${pro_img}" alt="" style="height:45px; width:45px;">
                                <div class="bundle-quantity">1</div>
                                <div class="bundle-close" data-step="0" data-variant="${pro_var}" data-index="0">
                                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <circle cx="8.5" cy="8.5" r="8" fill="#D10000"></circle>
                                    <path d="M5.5 5.5L11.5 11.5M11.5 5.5L5.5 11.5" stroke="white" stroke-width="1.5" stroke-linecap="round"></path>
                                  </svg>
                                </div>
                              </div>`;
              
               // Insert as the first child
               active_buy_box_mob.insertAdjacentHTML('afterbegin', box_html);
               if(active_buy_box_mob.nextElementSibling){
                  active_buy_box_mob.nextElementSibling.classList.add('active');
               }
               active_buy_box_mob.classList.remove('active');
            }

            const get_sel_price = parseInt(document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').getAttribute('data-price'));
            const get_curr_price = parseInt(atc_btn.getAttribute('data-price'));
            const total_price = get_sel_price + get_curr_price;

            document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').setAttribute('data-price',total_price);


            other_events();

          });
        }
      });
    }



    function other_events(){
      const main_atc_btn = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart a.add-to-cart-btn');
      const progress_bar_main = document.querySelector('.bundle-bottom-progress-bar');
      const total_pro_length = products_buyer.length;
      const selected_pros = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number .bundle-box-img');
      let selected_pro_length = selected_pros.length;
      var progressWithoutPercentage = 0;


      //for progress bar
      if(selected_pro_length >= total_pro_length){
        var progressWithoutPercentage = 100;
      } else {
        var remainPercentage = selected_pro_length/total_pro_length*100;
        progressWithoutPercentage = remainPercentage;
      }

      if (progress_bar_main) {
        let isAnimating = false;

        function move(targetPercentage) {
          if (isAnimating) return; // Prevent multiple animations at once
          isAnimating = true;

          const elem = document.querySelector(".bundle-bottom-progress-bar .bundle-progress");
          let currentWidth = parseInt(elem.style.width) || 0; // Start from current width
          const step = currentWidth < targetPercentage ? 1 : -1; // Decide direction

          const id = setInterval(() => {
            currentWidth += step;
            elem.style.width = currentWidth + "%";

            if ((step > 0 && currentWidth >= targetPercentage) ||
                (step < 0 && currentWidth <= targetPercentage)) {
              clearInterval(id);
              isAnimating = false;
            }
          }, 10);
        }

        move(progressWithoutPercentage);
      }
      //for progress bar

      if(selected_pro_length >= total_pro_length){
        if(product_cards.length> 0){
          product_cards.forEach(card => {
             const atc_btn = card.querySelector('.bundle-add-to-box-btn a.bundle_product_btn:not(.selected)');
             if(atc_btn){
                atc_btn.classList.add('disabled');
             }
          });
        }

        if(main_atc_btn){
          main_atc_btn.classList.remove('disabled');
        }

        const get_sel_price = parseInt(document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').getAttribute('data-price'));
        const total_price = parseInt(document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').getAttribute('data-total-price'));

        if(get_sel_price > total_price){
          document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').innerHTML = Shopify.formatMoney(get_sel_price,theme.settings.moneyFormat);

          const diff = get_sel_price - total_price;

          if(diff > 0){
            document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .bundle-price-row .save_price').innerHTML = "Save " + Shopify.formatMoney(diff,theme.settings.moneyFormat);
          }

        }
      }else{
        if(product_cards.length> 0){
          product_cards.forEach(card => {
             const atc_btn = card.querySelector('.bundle-add-to-box-btn a.bundle_product_btn');
             if(atc_btn){
                atc_btn.classList.remove('disabled');
             }
          });
        }

        if(main_atc_btn){
          main_atc_btn.classList.add('disabled');
        }

        document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').innerHTML = '';
        document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .bundle-price-row .save_price').innerHTML = '';
      }
      
    }

    // on close icon click remove
    // document.addEventListener('click', function (e) {
    //   if (e.target.closest('.bundle-close')) {
    //     const closeBtn = e.target.closest('.bundle-close');
    //     const variantId = closeBtn.getAttribute('data-variant');


    //     // --- 1. Subtract product price from total ---
    //     // const atcBtn = document.querySelector(`.product-bundle_row .product-bunlde_column[data-var-id="${variantId}"] .bundle-add-to-box-btn a.bundle_product_btn`);
    //     // if (atcBtn) {
    //     //   const productPrice = parseInt(atcBtn.getAttribute('data-price')) || 0;
    //     //   const priceElem = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price');
    //     //   let currentTotal = parseInt(priceElem.getAttribute('data-price')) || 0;

    //     //   let newTotal = currentTotal - productPrice;
    //     //   if (newTotal < 0) newTotal = 0;

    //     //   priceElem.setAttribute('data-price', newTotal);
    //     //   // priceElem.innerHTML = Shopify.formatMoney(newTotal, theme.settings.moneyFormat);
    //     // }


    //     // // Update product card count
    //     // // const productCard = document.querySelector(`.bundle-add-to-box-btn a.bundle_product_btn[data-var-id="${variantId}"]`)?.closest('.product-bunlde_column');
    //     // const productCard = document.querySelector(`.product-bundle_row .product-bunlde_column[data-var-id="${variantId}"]`);
    //     // if (productCard) {
    //     //   let addedCount = parseInt(productCard.getAttribute('data-added')) || 0;
    //     //   if (addedCount > 0) {
    //     //     addedCount--;
    //     //     productCard.setAttribute('data-added', addedCount);

    //     //     const atcBtn = productCard.querySelector('.bundle-add-to-box-btn a.bundle_product_btn');
    //     //     if (addedCount === 0) {
              
    //     //       const btn_text = atcBtn.getAttribute('data-atc-text');
    //     //       atcBtn.textContent = btn_text || 'Add to cart';
    //     //       atcBtn.classList.remove('selected');
    //     //       productCard.classList.remove('added');
    //     //     } else {
    //     //       atcBtn.textContent = `Added (${addedCount})`;
    //     //     }
    //     //   }
    //     // }
            

    //     // Select both desktop & mobile lists
    //     const lists = document.querySelectorAll('.product_buyuer_list');

    //     lists.forEach(list => {
    //       const items = list.querySelectorAll('.product_byuer_number');
    //       const allBoxes = [...list.querySelectorAll('.bundle-box-img')];

    //       // Remove matching bundle-box-img by variant
    //       const matchingBox = list.querySelector(`.bundle-box-img .bundle-close[data-variant="${variantId}"]`);
    //       if (matchingBox) matchingBox.closest('.bundle-box-img').remove();

    //       // Collect remaining boxes after removal
    //       const updatedBoxes = [...list.querySelectorAll('.bundle-box-img')];

    //       // Reindex
    //       items.forEach((item, index) => {
    //         // Remove any existing box before reassigning
    //         const existingBox = item.querySelector('.bundle-box-img');
    //         if (existingBox) existingBox.remove();

    //         if (updatedBoxes[index]) {
    //           item.prepend(updatedBoxes[index]);
    //           item.querySelector('.product_bundle_number').classList.add('hide');
    //         } else {
    //           item.querySelector('.product_bundle_number').classList.remove('hide');
    //         }
    //       });

    //       // Set active to first empty slot
    //       const firstEmpty = list.querySelector('.product_byuer_number:not(:has(.bundle-box-img))');
    //       list.querySelectorAll('.product_byuer_number').forEach(el => el.classList.remove('active'));
    //       if (firstEmpty) firstEmpty.classList.add('active');
    //     });

    //      other_events();
    //   }
    // });

    document.addEventListener('click', function (e) {
      const closeBtn = e.target.closest('.bundle-close');
      if (!closeBtn) return;

      const variantId = closeBtn.getAttribute('data-variant');
      const lists = document.querySelectorAll('.product_buyuer_list');

      let isAccessory;
      const removedBox = closeBtn.closest('.product_byuer_number');
      if (removedBox) {
      isAccessory = removedBox.classList.contains('product_accessories_numner');
      // do something with isAccessory
      }
      // Restore number visibility on the removed slot
      const numberSpan = removedBox.querySelector('.product_bundle_number');
      if (numberSpan) numberSpan.classList.remove('hide');

      const pro_var_price = parseInt(closeBtn.getAttribute('data-price'));
          const price_div_main = document.querySelector('.bundle-bottom-addtocart .price-section .bundle_discounttext_price');
          if(price_div_main){
            console.log('pro_var_price',pro_var_price);
            // products_bottom_bar.classList.remove('hide');
              const get_price = parseInt(price_div_main.getAttribute('data-total-price'));
            if (!isNaN(get_price)){
              const total_price = get_price - pro_var_price;

              if(total_price){
                price_div_main.innerHTML = "Total " + Shopify.formatMoney(total_price,theme.settings.moneyFormat);
                price_div_main.setAttribute('data-total-price',total_price);
              }
            }
          }

      lists.forEach(list => {
        const items = list.querySelectorAll('.product_byuer_number');
       
        // const isAccessory = removedBox.classList.contains('product_accessories_numner');

        // Remove the clicked bundle box
        const box = closeBtn.closest('.bundle-box-img');
        if (box) box.remove();



        // Clear all active states first
        list.querySelectorAll('.product_byuer_number').forEach(el => el.classList.remove('active'));

        // Activate the first empty non-accessory slot
        const firstEmptyProduct = list.querySelector('.product_byuer_number:not(.product_accessories_numner):not(:has(.bundle-box-img))');
        if (firstEmptyProduct) firstEmptyProduct.classList.add('active');

        // ----- Handle showing/hiding blocks -----
        const productSection = document.querySelector('.product_bundle_section');
        if (productSection) {
          const accessoriesBlock = productSection.querySelector('.product_inner_block.accessories_block');
          const allBlocks = productSection.querySelectorAll('.product_inner_block');

          // If removed item is accessory → keep accessories block visible
          if (isAccessory) {
            allBlocks.forEach(b => b.classList.add('hide'));
            if (accessoriesBlock) accessoriesBlock.classList.remove('hide');
            removedBox.classList.add('active');

            // const get_price = parseInt(closeBtn.getAttribute('data-price'));
            // const price_div_main = document.querySelector('.bundle-bottom-addtocart .price-section .bundle_discounttext_price');
            // if(price_div_main){
            //   const get_price = parseInt(price_div_main.getAttribute('data-ori-price'));
            //   if(get_price){
            //     price_div_main.innerHTML = "Total " + Shopify.formatMoney(get_price,theme.settings.moneyFormat);
            //   }
            // }
            
          } 
          else {
            // If a main product removed → hide accessories, show product block
            const allProductBlocks = productSection.querySelectorAll('.product_inner_block');
            allProductBlocks.forEach(b => b.classList.add('hide'));

            const firstProductBlock = productSection.querySelector('.product_inner_block.selected:not(.accessories_block)');
            if (firstProductBlock) firstProductBlock.classList.remove('hide');
          }


          

        }


        // const get_sel_price = parseInt(document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').getAttribute('data-price'));
        // const get_curr_price = parseInt(atc_btn.getAttribute('data-price'));
        // const total_price = get_sel_price + get_curr_price;

        // document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price').setAttribute('data-price',total_price);
        const products_buyer = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number:not(.product_accessories_numner)');
        const products_buyer_mobile = document.querySelectorAll('.product_bundle_bottom_bar .product_buyuer_list .product_byuer_number');

        const total_pro_length = products_buyer.length;
        const main_atc_btn = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart a.add-to-cart-btn');
        const selected_pros_total = document.querySelectorAll('.bundle-tab-content .product_buyuer_list .product_byuer_number:not(.product_accessories_numner) .bundle-box-img');
        let selected_pro_total_length = selected_pros_total.length;

        if(selected_pro_total_length >= total_pro_length){
          if(main_atc_btn){
            main_atc_btn.classList.remove('disabled');
          }
        }else{
          if(main_atc_btn){
            main_atc_btn.classList.add('disabled');
          }
        }

        // ----- Keep accessories fixed in position -----
        // Do NOT reindex or reorder accessories
      });
    });



    // //main ATC click
    // const main_add_to_cart = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart a.add-to-cart-btn');
    // if(main_add_to_cart){
    //   main_add_to_cart.addEventListener('click',function(e){
    //     e.preventDefault();
    //     main_add_to_cart.textContent = 'Adding...';
    //     var arrPdp = [];

    //     const sel_product_cards = document.querySelectorAll('.product-bundle_row .product-bunlde_column.added');

    //     if (sel_product_cards.length > 0) {
    //       sel_product_cards.forEach(card => {
    //         let quantity = parseInt(card.getAttribute('data-added')) || 0;
    //         let variant_id = card.getAttribute('data-var-id');

    //         if (quantity > 0 && variant_id) {
    //           arrPdp.push({
    //             id: variant_id,
    //             quantity: quantity
    //           });
    //         }
    //       });
    //     }

    //     // If no products selected, prevent submission
    //     if (arrPdp.length === 0) {
    //       // console.warn("No products selected to add to cart.");
    //       return;
    //     }

    //     //add items
    //     let formData = { items: arrPdp };

    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'X-Requested-With': 'xmlhttprequest'
    //       },
    //       body: JSON.stringify(formData),
    //       credentials: 'same-origin'
    //     })
    //     .then(response => response.json())
    //     .then(res => {     
    //       main_add_to_cart.textContent = 'Add to Cart';

    //        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
    //         bubbles: true
    //        }));

          
    //       //Reset product cards
    //       product_cards.forEach(card => {
    //         card.classList.remove('added');
    //         card.setAttribute('data-added', 0);
    //         const atcBtn = card.querySelector('.bundle-add-to-box-btn a.bundle_product_btn');
    //         const btn_text = atcBtn.getAttribute('data-atc-text') || 'Add to cart';
    //         atcBtn.textContent = btn_text;
    //         atcBtn.classList.remove('selected', 'disabled');
    //       });

    //       // Remove all bundle images (desktop + mobile)
    //       document.querySelectorAll('.bundle-box-img').forEach(img => img.remove());

    //       //Reset product number visibility and active state
    //       document.querySelectorAll('.product_buyuer_list .product_byuer_number').forEach((item, index) => {
    //         item.classList.remove('active');
    //         if (index === 0) item.classList.add('active');
    //         item.querySelector('.product_bundle_number').classList.remove('hide');
    //       });

    //       //Reset progress bar
    //       const progressElem = document.querySelector(".bundle-bottom-progress-bar .bundle-progress");
    //       if (progressElem) progressElem.style.width = "0%";

    //       //Reset price
    //       const priceElem = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .price-section .bundle_selected_price');
    //       if (priceElem) {
    //         priceElem.setAttribute('data-price', 0);
    //         priceElem.innerHTML = '';
    //       }

    //       //save element
    //       const saveElem = document.querySelector('.bundle-bottom-row .bundle-bottom-addtocart .bundle-price-row .save_price');
    //       if (saveElem) saveElem.textContent = '';

    //     })
    //     .catch(err => {
    //       console.error("Error adding bundle to cart:", err);
    //     });


    //   });
    // }

 });